export const questions = `
1. Walk me through a DCF.
2. Walk me through how you get from Revenue to Free Cash Flow in the projections.
3. What's an alternate way to calculate Free Cash Flow aside from taking Net Income, adding back Depreciation, and subtracting Changes in Operating Assets / Liabilities and CapEx?
4. Why do you use 5 or 10 years for DCF projections?
5. What do you usually use for the discount rate?
6. How do you calculate WACC?
7. How do you calculate the Cost of Equity?
8. How do you get to Beta in the Cost of Equity calculation?
9. Why do you have to un‐lever and re‐lever Beta?
10. Would you expect a manufacturing company or a technology company to have a higher Beta?
11. Let's say that you use Levered Free Cash Flow rather than Unlevered Free Cash Flow in your DCF – what is the effect?
12. If you use Levered Free Cash Flow, what should you use as the Discount Rate?
13. How do you calculate the Terminal Value?
14. Why would you use Gordon Growth rather than the Multiples Method to calculate the Terminal Value?
15. What's an appropriate growth rate to use when calculating the Terminal Value?
16. How do you select the appropriate exit multiple when calculating Terminal Value?
17. Which method of calculating Terminal Value will give you a higher valuation?
18. What's the flaw with basing terminal multiples on what public company comparables are trading at?
19. How do you know if your DCF is too dependent on future assumptions?
20. Should Cost of Equity be higher for a $5 billion or $500 million market cap company?
21. What about WACC – will it be higher for a $5 billion or $500 million company?
22. What's the relationship between debt and Cost of Equity?
23. Cost of Equity tells us what kind of return an equity investor can expect for investing in a given company – but what about dividends? Shouldn't we factor dividend yield into the formula?
24. How can we calculate Cost of Equity WITHOUT using CAPM
25. Two companies are exactly the same, but one has debt and one does not – which one will have the higher WACC?
26. Which has a greater impact on a company's DCF valuation – a 10% change in revenue or a 1% change in the discount rate?
27. What about a 1% change in revenue vs. a 1% change in the discount rate?
28. How do you calculate WACC for a private company?
29. What should you do if you don't believe management's projections for a DCF model?
30. Why would you not use a DCF for a bank or other financial institution?
31. What types of sensitivity analyses would we look at in a DCF?
32. A company has a high debt load and is paying off a significant portion of its principal each year. How do you account for this in a DCF?
`;